// export const backend_url = "http://localhost:8000";
// export const backend_url = ""; // For production

// Get from environment variable
export const backend_url = process.env.REACT_APP_BACKEND_URL;
